import React, {
  useEffect,
  useMemo,
  useState
} from "react";

import "./VaporLiquidGrid.css";

function VaporLiquidGrid({

  x = 100,
  y = 100,

  width = 250,
  height = 300

}) {

  /* =========================================================
     TAG VALUES
  ========================================================= */

  const [TT_16001, setTT_16001] =
    useState(25);

  const [FIC_16004, setFIC_16004] =
    useState(0);

  /* =========================================================
     RETRIEVE DCS TAGS
  ========================================================= */

  useEffect(() => {

    const interval = setInterval(() => {

      setTT_16001(
        Number(
          localStorage.getItem(
            "TT_16001"
          )
        ) || 25
      );

      setFIC_16004(
        Number(
          localStorage.getItem(
            "FIC_16004"
          )
        ) || 0
      );

    }, 100);

    return () =>
      clearInterval(interval);

  }, []);

  /* =========================================================
     VAPOR INTENSITY
  ========================================================= */

  const vaporIntensity =
    useMemo(() => {

      if(TT_16001 < 50){

        return 0;

      }

      return Math.min(
        (
          (TT_16001 - 50) / 250
        ),
        1
      );

    }, [TT_16001]);

  /* =========================================================
     DROPLET INTENSITY
  ========================================================= */

  const dropletIntensity =
    useMemo(() => {

      if(FIC_16004 < 0.1){

        return 0;

      }

      return Math.min(
        (
          (FIC_16004 - 0.1) / 1.9
        ),
        1
      );

    }, [FIC_16004]);

  /* =========================================================
     VAPOR PARTICLES
  ========================================================= */

  const vaporParticles =
    Math.floor(
      vaporIntensity * 45
    );

  /* =========================================================
     LIQUID DROPLETS
  ========================================================= */

  const liquidDroplets =
    Math.floor(
      dropletIntensity * 35
    );

  /* =========================================================
     UI
  ========================================================= */

  return (

    <div

      className="vapor-liquid-container"

      style={{

        position: "absolute",

        left: x,
        top: y,

        width,
        height,

        overflow: "hidden",
        pointerEvents: "none"

      }}

    >

      {/* =====================================================
          VAPOR PARTICLES
      ===================================================== */}

      {

        [...Array(vaporParticles)].map(
          (_, i) => (

            <div

              key={`vapor-${i}`}

              className="vapor-particle"

              style={{

                left:
                  `${
                    Math.random() * 100
                  }%`,

                bottom:
                  `${
                    Math.random() * 20
                  }%`,

                animationDuration:
                  `${
                    2 +
                    Math.random() * 4
                  }s`,

                opacity:
                  0.15 +
                  vaporIntensity * 0.85,

                width:
                  `${
                    8 +
                    vaporIntensity * 18
                  }px`,

                height:
                  `${
                    8 +
                    vaporIntensity * 18
                  }px`

              }}

            />

          )
        )

      }

      {/* =====================================================
          LIQUID DROPLETS
      ===================================================== */}

      {

        [...Array(liquidDroplets)].map(
          (_, i) => (

            <div

              key={`liquid-${i}`}

              className="liquid-droplet"

              style={{

                left:
                  `${
                    Math.random() * 100
                  }%`,

                top:
                  `${
                    Math.random() * 25
                  }%`,

                animationDuration:
                  `${
                    1 +
                    Math.random() * 2
                  }s`,

                opacity:
                  0.2 +
                  dropletIntensity * 0.8,

                width:
                  `${
                    2 +
                    dropletIntensity * 8
                  }px`,

                height:
                  `${
                    6 +
                    dropletIntensity * 20
                  }px`

              }}

            />

          )
        )

      }

    </div>

  );

}

export default VaporLiquidGrid;